export default __webpack_public_path__ + "static/media/ford_offer1.a4a88016.jpg";